import React from 'react'
import { Search } from "../Search";
import { RiArrowRightSLine } from "react-icons/ri";
import { IoIosMore } from "react-icons/io";
import { TransactionStatus } from "../../utils/Enums";
import { formatDateTime } from "../../utils/FormateDate";
import { FormattedData } from '../../utils/FormattedData';
import { Link } from 'react-router-dom';

const OverviewTable = ({recentOrder}) => {
  return (
    <div className="bg-white rounded-md shadow-lg p-4 mt-6">
      <div className="flex items-center justify-between px-4 pt-6 md:mb-4">
        <h2 className="font-bold text-lg">Recent Food Orders</h2>
        <Search />
      </div>
      <div className="flow-root bg-white px-4 py-4 rounded-md">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <table className="min-w-full">
                <thead>
                  <tr>
                    <th scope="col" className="py-4 pl-4 pr-3 whitespace-nowrap text-left text-xs font-bold uppercase text-[#090B0E]">
                      Name
                    </th>
                    <th scope="col" className="px-3 py-2 whitespace-nowrap text-left text-xs font-bold uppercase text-[#090B0E]">
                      Food Details
                    </th>
                    <th scope="col" className="px-3 py-2 whitespace-nowrap text-left text-xs font-bold uppercase text-[#090B0E]">
                      Payment Method
                    </th>
                    <th scope="col" className="px-3 py-2 whitespace-nowrap text-left text-xs font-bold uppercase text-[#090B0E]">
                      Date and Time Ordered
                    </th>
                    <th scope="col" className="px-3 py-2 whitespace-nowrap text-center text-xs font-bold uppercase text-[#090B0E]">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {recentOrder && recentOrder?.map((order, index) =>(
                    <tr key={index} className="border-b border-b-primaryGray gap-5">
                      <td className="whitespace-nowrap px-3 py-2 text-xs md:text-sm text-[#090B0E]/80 capitalize">{order?.customerName}</td>
                      <td className="whitespace-nowap md:max-w-80 px-3 py-2 text-xs md:text-sm text-[#0A0A0A] capitalize">{FormattedData(order?.foodDetails)}</td>
                      <td className="whitespace-nowap px-3 py-2 text-xs md:text-sm text-left text-[#151A20B2] capitalize">{TransactionStatus[order?.paymentStatus]}</td>
                      <td className="whitespace-nowap px-3 py-2 text-xs text-#151A20E5 text-left capitalize">{formatDateTime(order?.orderDateTime)}</td>
                      <td className="whitespace-nowrap px-3 text-lg py-2 text-[#B3B3B3] flex items-center justify-center">{<IoIosMore />}</td>
                      </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {recentOrder && (
          <Link to='/transaction' className="flex items-center justify-center py-5 text-primaryRed">
          <p className="text-md">View All Orders</p>
          <RiArrowRightSLine className="ml-1 text-lg" />
        </Link>
        )}
    </div>
  );
};

export default OverviewTable;